import StorybookUIRoot from "@/.storybook";

const Tab = () => {
  return <StorybookUIRoot />;
};

// eslint-disable-next-line import-x/no-unused-modules -- Modal/Tab/TabLayout/Screen/Home get used in expo routing but in a way that TypeScript can not infer
export default Tab;
